export const complianceGuides = [
  {
    id: 'gap-assessment',
    number: '01',
    title: 'How to run a DPDPA gap assessment',
    summary: 'The first workstream before anything else — find out exactly where your organisation stands against the Act.',
    steps: [
      'Inventory every system, form, vendor and app that collects personal data of individuals in India.',
      'Map each data flow to a lawful basis — consent under Section 6, or a legitimate use under Section 7.',
      'Review current notices against Section 5\'s itemised disclosure requirements.',
      'Score each business unit on notice, consent, security safeguards, breach-readiness and rights-fulfilment maturity.',
      'Prioritise remediation by penalty exposure — security safeguards (₹250 cr) and breach notification (₹200 cr) first.',
    ],
  },
  {
    id: 'dpia',
    number: '02',
    title: 'Conducting a Data Protection Impact Assessment (DPIA)',
    summary: 'Mandatory for Significant Data Fiduciaries under Rule 13, and good practice for everyone else handling sensitive processing.',
    steps: [
      'Describe the processing activity, its purpose, and the categories of personal data involved.',
      'Assess necessity and proportionality — is this the least amount of data needed for the purpose?',
      'Identify risks to Data Principals: unauthorised access, profiling, discrimination, re-identification.',
      'Document mitigation measures — encryption, access control, anonymisation, retention limits.',
      'Repeat the DPIA periodically and whenever processing purposes materially change.',
    ],
  },
  {
    id: 'consent-notice-drafting',
    number: '03',
    title: 'Drafting Section 5 notices and Section 6 consent flows',
    summary: 'Turn legal text into a sign-up screen users can actually understand and act on.',
    steps: [
      'List every purpose for which personal data is collected — no bundled or vague purposes.',
      'Write each purpose in plain language, ideally offered in the language the user understands.',
      'Design consent capture as a clear affirmative action — no pre-ticked boxes, no implied consent.',
      'Build a withdrawal flow that is as easy to use as the original consent flow.',
      'Log every consent event with timestamp, version of notice shown, and scope granted — this is your audit trail.',
    ],
  },
  {
    id: 'breach-response-playbook',
    number: '04',
    title: 'Building a 72-hour breach response playbook',
    summary: 'Rule 7 gives you 72 hours to notify the Board and every affected Data Principal — with no materiality threshold.',
    steps: [
      'Define what qualifies as a "personal data breach" for your organisation and who has authority to classify one.',
      'Build a detection and logging layer aligned to Rule 6\'s reasonable security safeguards.',
      'Pre-draft Board and Data-Principal notification templates so drafting isn\'t done under pressure.',
      'Establish an internal escalation chain from detection to Board notification, tested via tabletop exercises.',
      'Maintain an evidence log of the breach, response actions and timelines for Board scrutiny.',
    ],
  },
  {
    id: 'ropa-building',
    number: '05',
    title: 'Building a Record of Processing Activities (RoPA)',
    summary: 'The single source of truth the Board will expect every audit-ready organisation to have.',
    steps: [
      'Catalogue every processing activity: purpose, data categories, lawful basis, retention period.',
      'Record every third party — Data Processors and other Data Fiduciaries — data is shared with.',
      'Tag each activity with its erasure timeline under Rule 8 and the Third Schedule.',
      'Assign an owner within the business for each recorded processing activity.',
      'Review and update the RoPA on a fixed cadence, not just when a new project launches.',
    ],
  },
  {
    id: 'cross-border-transfer',
    number: '06',
    title: 'Cross-border data transfer compliance under Section 16',
    summary: 'India takes a blacklist approach — transfers are allowed by default unless a destination is restricted.',
    steps: [
      'Map where personal data of Indian Data Principals is stored or processed outside India — cloud regions, vendors, group entities.',
      'Track Central Government notifications restricting transfer to specific countries or territories.',
      'Layer in contractual safeguards with overseas processors regardless of statutory permissibility.',
      'Reassess sectoral restrictions — some regulators (e.g. RBI data localisation norms) impose stricter limits than the DPDPA itself.',
      'Document the legal basis for every cross-border flow in your RoPA.',
    ],
  },
];
